import React from 'react'

import { Button, Form, Icon, Row } from 'antd'
import { Formik } from 'formik'

import CustomInput from '../../../components/CustomInput/customInput'
import CustomSelect from '../../../components/CustomSelect/customSelect'
import { CULTIVARS_SCHEMA } from './CultivarsSchema'

const CreateCultivarsHistory = ({
  onCreateCultivar,
  formattedMaterials = [],
  formattedDemandTypes = [],
  formattedCultivarsTypes = []
}) => {
  function onSubmit(values, { resetForm }) {
    onCreateCultivar({ ...values })
    resetForm()
  }

  return (
    <Formik
      enableReinitialize
      initialValues={{}}
      validationSchema={CULTIVARS_SCHEMA}
      onSubmit={onSubmit}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ values, errors, setFieldValue, submitForm }) => (
        <Form layout="vertical">
          <Row type="flex" justify="space-between">
            <CustomSelect
              showSearch
              field="materialsId"
              errors={errors}
              setFieldValue={setFieldValue}
              rowSpan={8}
              value={values}
              values={formattedMaterials}
            />
            <CustomSelect
              showSearch
              field="cultivarsDemandTypeId"
              errors={errors}
              setFieldValue={setFieldValue}
              rowSpan={5}
              value={values}
              values={formattedDemandTypes}
            />
            <CustomInput
              field="area"
              type="number"
              errors={errors}
              setFieldValue={setFieldValue}
              rowSpan={5}
              value={values}
              handleBlur={() => {}}
            />
            <CustomSelect
              showSearch
              field="cultivarsTypeId"
              errors={errors}
              setFieldValue={setFieldValue}
              rowSpan={5}
              value={values}
              values={formattedCultivarsTypes}
            />
            <Button type="primary" className="button-action-plus" onClick={submitForm}>
              <Icon type="plus" />
            </Button>
          </Row>
        </Form>
      )}
    </Formik>
  )
}

export default CreateCultivarsHistory
